import { Injectable } from '@angular/core';
import { DataDefinitionOptions } from '../../../models/home.model';

@Injectable({
  providedIn: 'root'
})
export class MeasureTaskService {
  
  constructor() { }

  public degree = [
    { id: 0, value: "0%" },
    { id: 25, value: "25%" },
    { id: 50, value: "50%" },
    { id: 75, value: "75%" },
    { id: 100, value: "100%" }
  ];

  public maturityLevel: DataDefinitionOptions[] = [
    { name: 'HG1', value: 'HG1' },
    { name: 'HG2', value: 'HG2' },
    { name: 'HG3', value: 'HG3' },
    { name: 'HG4', value: 'HG4' },
    { name: 'HG5', value: 'HG5' }
  ];
}